import React, { useEffect } from "react";
import { useLocation } from "@reach/router"

const ScrollToTop = () => {
    if (typeof window === "undefined") {
        return null // or a loader/placeholder
    }
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

export default ScrollToTop;